import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/client";

type ActivateTrialResult = {
  ok: boolean;
  trialStartedAt: number;
  trialExpiresAt: number;
  daysRemaining: number;
};

type AdminManageTrialResult = {
  ok: boolean;
  action: string;
  tier?: string;
  expiresAt?: number;
};

export async function activateTrial(): Promise<ActivateTrialResult> {
  const fn = httpsCallable<void, ActivateTrialResult>(functions, "activateTrial");
  const result = await fn();
  return result.data;
}

export async function adminActivateTrial(targetUid: string): Promise<AdminManageTrialResult> {
  const fn = httpsCallable<unknown, AdminManageTrialResult>(functions, "adminManageTrial");
  const result = await fn({ action: "activate", targetUid });
  return result.data;
}

export async function adminRevokeTrial(targetUid: string): Promise<AdminManageTrialResult> {
  const fn = httpsCallable<unknown, AdminManageTrialResult>(functions, "adminManageTrial");
  const result = await fn({ action: "revoke", targetUid });
  return result.data;
}

export async function adminConvertToPro(targetUid: string): Promise<AdminManageTrialResult> {
  const fn = httpsCallable<unknown, AdminManageTrialResult>(functions, "adminManageTrial");
  const result = await fn({ action: "convert_pro", targetUid });
  return result.data;
}

export async function adminConvertToPremium(targetUid: string): Promise<AdminManageTrialResult> {
  const fn = httpsCallable<unknown, AdminManageTrialResult>(functions, "adminManageTrial");
  const result = await fn({ action: "convert_premium", targetUid });
  return result.data;
}
